/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListExternalUserDefaultBudgetEventsRequest = {
  orgId?: string | undefined;
};

export const ListExternalUserDefaultBudgetEventsType = {
  ThresholdAlert: "threshold_alert",
  Blocked: "blocked",
} as const;
export type ListExternalUserDefaultBudgetEventsType = ClosedEnum<
  typeof ListExternalUserDefaultBudgetEventsType
>;

export type ListExternalUserDefaultBudgetEventsData = {
  id: string;
  budgetId: string;
  type: ListExternalUserDefaultBudgetEventsType;
  pct: number | null;
  periodKey: string;
  targetId: string;
  spendSnapshot: number;
  limitSnapshot: number;
  createdAt: string;
};

/**
 * OK
 */
export type ListExternalUserDefaultBudgetEventsResponseBody = {
  object: "list";
  data: Array<ListExternalUserDefaultBudgetEventsData>;
};

/** @internal */
export const ListExternalUserDefaultBudgetEventsRequest$inboundSchema:
  z.ZodType<ListExternalUserDefaultBudgetEventsRequest, z.ZodTypeDef, unknown> =
    z.object({
      org_id: z.string().optional(),
    }).transform((v) => {
      return remap$(v, {
        "org_id": "orgId",
      });
    });
/** @internal */
export type ListExternalUserDefaultBudgetEventsRequest$Outbound = {
  org_id?: string | undefined;
};

/** @internal */
export const ListExternalUserDefaultBudgetEventsRequest$outboundSchema:
  z.ZodType<
    ListExternalUserDefaultBudgetEventsRequest$Outbound,
    z.ZodTypeDef,
    ListExternalUserDefaultBudgetEventsRequest
  > = z.object({
    orgId: z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      orgId: "org_id",
    });
  });

export function listExternalUserDefaultBudgetEventsRequestToJSON(
  listExternalUserDefaultBudgetEventsRequest:
    ListExternalUserDefaultBudgetEventsRequest,
): string {
  return JSON.stringify(
    ListExternalUserDefaultBudgetEventsRequest$outboundSchema.parse(
      listExternalUserDefaultBudgetEventsRequest,
    ),
  );
}
export function listExternalUserDefaultBudgetEventsRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListExternalUserDefaultBudgetEventsRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListExternalUserDefaultBudgetEventsRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListExternalUserDefaultBudgetEventsRequest' from JSON`,
  );
}

/** @internal */
export const ListExternalUserDefaultBudgetEventsType$inboundSchema:
  z.ZodNativeEnum<typeof ListExternalUserDefaultBudgetEventsType> = z
    .nativeEnum(ListExternalUserDefaultBudgetEventsType);
/** @internal */
export const ListExternalUserDefaultBudgetEventsType$outboundSchema:
  z.ZodNativeEnum<typeof ListExternalUserDefaultBudgetEventsType> =
    ListExternalUserDefaultBudgetEventsType$inboundSchema;

/** @internal */
export const ListExternalUserDefaultBudgetEventsData$inboundSchema: z.ZodType<
  ListExternalUserDefaultBudgetEventsData,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  budget_id: z.string(),
  type: ListExternalUserDefaultBudgetEventsType$inboundSchema,
  pct: z.nullable(z.number()),
  period_key: z.string(),
  target_id: z.string(),
  spend_snapshot: z.number(),
  limit_snapshot: z.number(),
  created_at: z.string(),
}).transform((v) => {
  return remap$(v, {
    "budget_id": "budgetId",
    "period_key": "periodKey",
    "target_id": "targetId",
    "spend_snapshot": "spendSnapshot",
    "limit_snapshot": "limitSnapshot",
    "created_at": "createdAt",
  });
});
/** @internal */
export type ListExternalUserDefaultBudgetEventsData$Outbound = {
  id: string;
  budget_id: string;
  type: string;
  pct: number | null;
  period_key: string;
  target_id: string;
  spend_snapshot: number;
  limit_snapshot: number;
  created_at: string;
};

/** @internal */
export const ListExternalUserDefaultBudgetEventsData$outboundSchema: z.ZodType<
  ListExternalUserDefaultBudgetEventsData$Outbound,
  z.ZodTypeDef,
  ListExternalUserDefaultBudgetEventsData
> = z.object({
  id: z.string(),
  budgetId: z.string(),
  type: ListExternalUserDefaultBudgetEventsType$outboundSchema,
  pct: z.nullable(z.number()),
  periodKey: z.string(),
  targetId: z.string(),
  spendSnapshot: z.number(),
  limitSnapshot: z.number(),
  createdAt: z.string(),
}).transform((v) => {
  return remap$(v, {
    budgetId: "budget_id",
    periodKey: "period_key",
    targetId: "target_id",
    spendSnapshot: "spend_snapshot",
    limitSnapshot: "limit_snapshot",
    createdAt: "created_at",
  });
});

export function listExternalUserDefaultBudgetEventsDataToJSON(
  listExternalUserDefaultBudgetEventsData:
    ListExternalUserDefaultBudgetEventsData,
): string {
  return JSON.stringify(
    ListExternalUserDefaultBudgetEventsData$outboundSchema.parse(
      listExternalUserDefaultBudgetEventsData,
    ),
  );
}
export function listExternalUserDefaultBudgetEventsDataFromJSON(
  jsonString: string,
): SafeParseResult<
  ListExternalUserDefaultBudgetEventsData,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListExternalUserDefaultBudgetEventsData$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListExternalUserDefaultBudgetEventsData' from JSON`,
  );
}

/** @internal */
export const ListExternalUserDefaultBudgetEventsResponseBody$inboundSchema:
  z.ZodType<
    ListExternalUserDefaultBudgetEventsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    object: z.literal("list"),
    data: z.array(
      z.lazy(() => ListExternalUserDefaultBudgetEventsData$inboundSchema),
    ),
  });
/** @internal */
export type ListExternalUserDefaultBudgetEventsResponseBody$Outbound = {
  object: "list";
  data: Array<ListExternalUserDefaultBudgetEventsData$Outbound>;
};

/** @internal */
export const ListExternalUserDefaultBudgetEventsResponseBody$outboundSchema:
  z.ZodType<
    ListExternalUserDefaultBudgetEventsResponseBody$Outbound,
    z.ZodTypeDef,
    ListExternalUserDefaultBudgetEventsResponseBody
  > = z.object({
    object: z.literal("list"),
    data: z.array(
      z.lazy(() => ListExternalUserDefaultBudgetEventsData$outboundSchema),
    ),
  });

export function listExternalUserDefaultBudgetEventsResponseBodyToJSON(
  listExternalUserDefaultBudgetEventsResponseBody:
    ListExternalUserDefaultBudgetEventsResponseBody,
): string {
  return JSON.stringify(
    ListExternalUserDefaultBudgetEventsResponseBody$outboundSchema.parse(
      listExternalUserDefaultBudgetEventsResponseBody,
    ),
  );
}
export function listExternalUserDefaultBudgetEventsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  ListExternalUserDefaultBudgetEventsResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListExternalUserDefaultBudgetEventsResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListExternalUserDefaultBudgetEventsResponseBody' from JSON`,
  );
}
